















































import Vue from "vue";
import ResetPasswordForm from "@/components/organisms/ResetPasswordForm/index.vue";

export default Vue.extend({
  name: "forget-password",
  components: { ResetPasswordForm },
  data() {
    return {
      username: "",
    };
  },
  props: {
    forgotPasswrodRequestIsDone: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    submit() {
      const username = this.username;
      this.$emit("forgotPassword", username);
    },
    resendAuthCode() {
      this.$emit("resendAuthCode");
    },
    resetPassword(newCredential: any) {
      this.$emit("resetPassword", newCredential);
    },
    resendMFACode() {
      // TODO: re-send
    },
    goLogin() {
      this.$emit("goLogin");
    },
  },
});
